import emailjs from 'emailjs-com';
import toast from 'react-hot-toast';


const SERVICE_ID = "service_kk2m3hg";
const PUBLIC_KEY = "EKeEf3KvMYdi080Cg";
const TEMPLATES = {
  contact: "template_d3ki5xq",
  quote: "template_drtns1t"
};

emailjs.init(PUBLIC_KEY);

export const sendEmail = async (data, formType) => {
  try {
    const templateId = TEMPLATES[formType];
    if (!templateId) {
      throw new Error("Invalid form type");
    }

    const formatDate = (date) => {
      const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
      const day = String(date.getDate()).padStart(2, '0');
      const year = date.getFullYear();
      return `${month}/${day}/${year}`;
    };

    // Format the data based on form type
    const formattedData = {
      ...data,
      submission_date: new Date().toLocaleString(),
      additionalDropoffs: data.additionalDropoffs || [],
      // For quote form, combine all fields into a formatted message
      ...(formType === 'quote' && {
        message: `
          Name: ${data.name || 'N/A'}
          Email: ${data.email || 'N/A'}
          Phone: ${data.phone || 'N/A'}
          Pickup: ${data.pickup || 'N/A'}
          Pickup Type: ${data.pickupType || 'House'}
          Starting Location Sq.ft: ${data.startSQ || 'N/A'}
          Dropoff: ${data.dropoff || 'N/A'}
          Dropoff Type: ${data.dropoffType || 'N/A'}
          Additional: ${data.additional || 'N/A'}
          Additional Type: ${data.additionalType || 'N/A'}
          Dropoff Location Sq.ft: ${data.dropSQ || 'N/A'}
          Bedrooms: ${data.bedrooms || 'N/A'}
          Large Items: ${data.large_items || 'None'}
          Boxes: ${data.boxes || '0'}
          Stairs: ${data.stairs || 'N/A'}
          Elevator: ${data.elevator || 'N/A'}
          Parking: ${data.parking || 'N/A'}
          Specialty Items: ${data.specialty_items || 'None'}
          Move Date: ${formatDate(new Date(data.move_date))}
          Additional Info: ${data.additional_info || 'None'}
          Submission Date: ${formatDate(new Date())}
        `.trim()
      }),
    };

    console.log("Formatted Data:", formattedData); // Debugging

    const response = await emailjs.send(
      SERVICE_ID,
      templateId,
      formattedData,
      PUBLIC_KEY
    );

    if (response.status === 200) {
      toast.success("Message sent successfully!");
      return true;
    } else {
      throw new Error("Failed to send message");
    }
  } catch (error) {
    console.error("Email error:", error);
    toast.error("Failed to send message. Please try again.");
    return false;
  }
};